import axios from 'src/app-axios';
import Constants from 'src/constants';

export const organization = {
  namespaced: true,
  state: {
    userOrganizations: [],
    selectedOrganization: {},
    organizationsPendingRequests: [],
    organizationDocuments: [],
    workerCategories: [],
    dailyReports: {},
    organizationSettings: {
      locationVerification: false,
      documentVerification: false,
    },
  },
  getters: {
    getUserOrganizations (state) {
      return state.userOrganizations;
    },
    getSelectedOrganization (state) {
      return state.selectedOrganization;
    },
    getOrganizationsPendingRequests (state) {
      return state.organizationsPendingRequests;
    },
    getOrganizationDocuments (state) {
      return state.organizationDocuments;
    },
    getWorkerCategories (state) {
      return state.workerCategories;
    },
    getOrganizationSettings (state) {
      return state.organizationSettings;
    },
    getDailyReports (state) {
      return state.dailyReports;
    },
  },
  mutations: {
    setUserOrganization (state, data) {
      state.userOrganizations = data;
    },
    setSelectedOrganization (state, data) {
      state.selectedOrganization = data;
    },
    setOrganizationsPendingRequests (state, data) {
      state.organizationsPendingRequests = data;
    },
    setOrganizationDocuments (state, data) {
      state.organizationDocuments = data;
    },
    setWorkerCategories (state, data) {
      state.workerCategories = data;
    },
    setOrganizationSettings (state, data) {
      state.organizationSettings = data;
    },
    setDailyReports (state, data) {
      state.dailyReports = data;
    },
  },
  actions: {
    async fetchUserOrganizations ({ dispatch, commit }, payload) {
      const url = 'api/devices/app-users/organizations/requests';
      try {
        const organizations = await axios.get(url, payload);
        commit('setUserOrganization', organizations.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the organizations list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async setSelectOrganization ({ dispatch, commit }, payload) {
      const url = 'api/devices/app-users/select-organization';
      try {
        await axios.put(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in setting organization.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    selectedOrganization ({ commit }, payload) {
      commit('setSelectedOrganization', payload);
    },
    async fetchOrganizationsPendingRequests ({ dispatch, commit }, payload) {
      const url = 'api/devices/app-users/organizations/requests';
      try {
        const pendingRequests = await axios.get(url, payload);
        commit('setOrganizationsPendingRequests', pendingRequests.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the organizations pending requests.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async acceptOrganizationRequest ({ dispatch }, payload) {
      const url = 'api/devices/app-users/organizations/requests';
      try {
        await axios.post(url, payload.organizationExtId);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in accepting the request.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async fetchOrganizationDocuments ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/documents`;
      try {
        const documents = await axios.get(url);
        commit('setOrganizationDocuments', documents.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the documents.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async fetchWorkerCategories ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/worker-category`;
      try {
        const documents = await axios.get(url);
        commit('setWorkerCategories', documents.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the documents.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async fetchOrganizationSettings ({ dispatch, commit }, payload) {
      const url = `api/devices/organization-settings/${
        payload.organization_id
          ? payload.organization_id
          : payload.organization.external_id
      }`;
      try {
        const documents = await axios.get(url);
        commit('setOrganizationSettings', documents.data.settings);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the documents.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async fetchDailyReports ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organization.external_id}/daily-reports`;
      try {
        const reports = await axios.get(url);
        commit('setDailyReports', reports.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in getting the daily reports.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
  },
};
